import superjson from "superjson";

export type JsonStorage<Value> = {
  getItem(key: string, initialValue: Value): Value;
  setItem(key: string, value: Value): void;
  removeItem(key: string): void;
  subscribe(
    key: string,
    callback: (value: Value) => void,
    initialValue: Value,
  ): () => void;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const jsonStorage: JsonStorage<any> = {
  getItem: (key, initialValue) => {
    const value = localStorage.getItem(key);

    if (value === null) {
      return initialValue;
    }

    return superjson.parse(value);
  },
  setItem: (key, value) => {
    localStorage.setItem(key, superjson.stringify(value));
  },
  removeItem: (key) => {
    localStorage.removeItem(key);
  },
  subscribe(key, callback, initialValue) {
    const abort = new AbortController();

    window.addEventListener(
      "storage",
      (e) => {
        if (e.storageArea === localStorage && e.key === key) {
          if (!e.newValue) {
            return;
          }
          callback(superjson.parse(e.newValue) ?? initialValue);
        }
      },
      {signal: abort.signal},
    );

    return () => {
      abort.abort();
    };
  },
};
